import { GameType } from '../../model/enumeration/GameType.enum';
import { PokerRoom } from '../../model/enumeration/PokerRoom';
import { TableUnion } from '../../model/TableUnion';

export interface AvailableBotsForSitProps {
  tableId: string;
  room: PokerRoom;
  gameType: GameType;
  limit: number;
  union: TableUnion;
  isVisible: boolean;
  onHide: () => void;
  place?: number;
  isTableFull: boolean;
  tablePlayerCount: number;
  fromLobbyTable: boolean;
}

export enum AvailableBotsSortingOptions {
  OPENED_TABLES = 'Opened tables',
}
